export default __webpack_public_path__ + "img/aba1338da56a78e88454c95460152f6d.svg";